import { FC } from "react";
import { Trans, useTranslation } from "react-i18next";

// Renders a locale string, turning <b>...</b> markup into emphasised keywords
export const EmphasisText: FC<{ i18nKey: string }> = ({ i18nKey }) => {
    // useTranslation subscribes this component to language changes
    const { t } = useTranslation();
    return <Trans t={t} i18nKey={i18nKey} components={{ b: <strong className="text-emphasis" /> }} />;
};
